class CreateOwnSet extends HTMLElement {
    constructor() {
        super();
    
        this.checkboxes = this.querySelectorAll(
            '.create-own-set__product input[type="checkbox"]'
        );
        this.savedItemsDiv = document.querySelector("[data-set-value]");
        this.savedProductItems = this.querySelectorAll(".saved_item-select");
        this.currentCount = document.querySelector("[data-current-count]");
        this.addBtn = document.querySelector("[data-add-set]"); 
        this.getCheckedItems();
        this.handleAddSetToCart();
    }
  
    getCheckedItems() {
        this.checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
            const productHandle = checkbox.value;
            // const productName =
            //   checkbox.parentElement.querySelector("label").textContent;
            const productName = checkbox.dataset.title;
            const productB = checkbox.closest(".create-own-set__details");
            const clonedElement = productB.cloneNode(true);
    
            if (checkbox.checked) {
                this.addToSavedItems(
                productHandle,
                productName,
                clonedElement,
                checkbox
                );
            } else {
                this.removeFromSavedItems(
                productHandle,
                productName,
                clonedElement,
                checkbox
                );
            }
            });
        });
    }
  
    addToSavedItems(handle, name, cloned, checkbox) {

        let countSaved = parseInt(
            this.savedItemsDiv.value
        );
    
        if (countSaved <= 5) {
            this.savedItemsDiv.value = countSaved + 1;
            let UpdatedCount = parseInt(
            this.savedItemsDiv.value
            );
    
            checkbox
            .closest(".create-own-set__details")
            .querySelector(".number").innerHTML = UpdatedCount;
    
            this.currentCount.innerHTML = UpdatedCount;

    
            const savedItem = document.createElement("div");
            savedItem.classList.add("saved-item");
            savedItem.setAttribute("data-handle", handle);
    
            for (const checkbox of this.savedProductItems) {
                if (!checkbox.classList.contains("active")) {

                    checkbox.classList.add("active");
                    checkbox.setAttribute("data-handle", handle);
                    checkbox.setAttribute("data-title", name);
                    break; // This will exit the loop
                }
            }
    
            UpdatedCount == 6? this.addBtn.removeAttribute("disabled"):this.addBtn.setAttribute("disabled","disabled")
            
        } else {
            alert("You can only select 6 perfumes");
            checkbox.checked = false;
            return;
        }
    }
  
    removeFromSavedItems(handle, name, cloned, checkbox) {
        let countSaved = parseInt(
            this.savedItemsDiv.value
        );
        this.savedItemsDiv.value = countSaved - 1;
        let UpdatedCount = parseInt(
            this.savedItemsDiv.value
        );
    
        checkbox
            .closest(".create-own-set__details")
            .querySelector(".number").innerHTML = UpdatedCount;
        let checkedCheckbox = null;
    
        this.currentCount.innerHTML = UpdatedCount;
      
    
        UpdatedCount == 6?this.addBtn.removeAttribute("disabled"):this.addBtn.setAttribute("disabled","disabled");
       
    
        const itemToRemove = document.querySelector(
            `.saved_items [data-handle="${handle}"]`
        );
        
        if (itemToRemove) {
            itemToRemove.classList.remove("active");
            itemToRemove.removeAttribute("data-handle");
            itemToRemove.removeAttribute("data-title");
        }
    
        let checkedCheckboxIndex = 0;
        this.checkboxes.forEach((checkbox, index) => {
            if (checkbox.checked) {
            checkedCheckboxIndex++;
            checkbox
                .closest(".create-own-set__details")
                .querySelector(".number").innerHTML = checkedCheckboxIndex;
            }
        });
    }

    handleAddSetToCart() {
        let addToCartButton = this.addBtn;
        // Add a click event listener to the button
        if (addToCartButton) {
          addToCartButton.addEventListener("click", async (e) => {
            
            let savedItems = document.querySelectorAll(".saved_item-select.active");
            if (savedItems.length !== 6) {
              alert("Please select 6 samples before adding to cart.");
              return; 
            }
            this.addBtn.disabled = true;
            // let productData = [];
            let propertiesData = {};
            let bundleSelectionArray = [];
  
            savedItems.forEach(function (item, idx) {
              let variantId = item.getAttribute("data-handle");
              let title = item.getAttribute("data-title");
              // productData.push({ id: variantId, quantity: 1 });
              propertiesData[`Sample ${idx + 1}`] = title; // Changed to key-value pair
              bundleSelectionArray.push(title); // Add free wash bag to bundle selection
            });
  
            const bundleVariantId = +document.querySelector(
              "#bundle-variation-id"
            ).value;
            const bundleProductId =
              +document.querySelector("#bundle-product-id").value;
  
            // Concatenate bundle selection titles in the required format
            let bundleSelectionString = bundleSelectionArray.join(" <> ");
            propertiesData["_bundle_selection"] = bundleSelectionString;
  
            const data = {
              items: [
                {
                  quantity: 1,
                  id: bundleVariantId,
                  properties: propertiesData,
                  "product-id": bundleProductId,
                },
              ],
            };
  
            await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
              .then((response) => response.json())
              .then((responseData) => {
                
                // Dispatch cart:change event to update cart count
                document.dispatchEvent(
                  new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                      cart: responseData,
                      baseEvent: "variant:add"
                    }
                  })
                );
                
                // Find and open the cart drawer directly
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  cartDrawer.show();
                } else {
                  console.error("Cart drawer element not found");
                }
                
                // Also refresh the cart to ensure everything is up to date
                document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              })
              .catch(function (error) {
                console.error(error);
              })
              .finally(function () {
                // Any cleanup code can go here
              });
              this.addBtn.disabled = false;
          });
        }
      }
    
  
    
    
}
  
customElements.define("create-own-set", CreateOwnSet);
  
  
  